export default {"src":"/_next/static/media/AKAM.b1544e13.svg","height":18,"width":18};